import { AuthServiceInterface } from '@freelancer/auth';
import { DatastoreInterface } from '@freelancer/datastore/core';
import { DatastoreTestingController } from '@freelancer/datastore/testing';
import { toNumber } from '@freelancer/utils';
import { map, take } from 'rxjs/operators';
import {
  printDatastoreState,
  setAuth,
  setDatastoreController,
} from './document-creators';
import { constructInitialStoreState } from './initial-state';
import { addPushTransformers } from './push-transformers';

export function datastoreInitializer(
  { isTesting } = { isTesting: true },
): (
  auth: AuthServiceInterface,
  datastore: DatastoreInterface,
  datastoreController: DatastoreTestingController,
) => Promise<void> {
  return (
    auth: AuthServiceInterface,
    datastore: DatastoreInterface,
    datastoreController: DatastoreTestingController,
  ) => {
    setAuth(auth);
    setDatastoreController(datastoreController);

    auth.setSession('1', ''); // assume initialisation is for logged-in user

    return auth
      .getUserId()
      .pipe(
        take(1),
        map(authUid => toNumber(authUid)),
      )
      .toPromise()
      .then(authUid => {
        addPushTransformers(authUid);

        if (!isTesting) {
          constructInitialStoreState(auth, datastore, authUid);
          printDatastoreState();
        }
      })
      .catch(err => console.error('Failed to initialize datastore:', err));
  };
}
